/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageClientToolBreakdownSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageClientToolBreakdownSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageClientToolBreakdownSecurity = {
  option1?: GetToolUsageClientToolBreakdownSecurityOption1 | undefined;
  option2?: GetToolUsageClientToolBreakdownSecurityOption2 | undefined;
};

export type GetToolUsageClientToolBreakdownRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageClientToolBreakdownSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageClientToolBreakdownSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetToolUsageClientToolBreakdownSecurityOption1$Outbound,
    GetToolUsageClientToolBreakdownSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getToolUsageClientToolBreakdownSecurityOption1ToJSON(
  getToolUsageClientToolBreakdownSecurityOption1:
    GetToolUsageClientToolBreakdownSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageClientToolBreakdownSecurityOption1$outboundSchema.parse(
      getToolUsageClientToolBreakdownSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageClientToolBreakdownSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageClientToolBreakdownSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetToolUsageClientToolBreakdownSecurityOption2$Outbound,
    GetToolUsageClientToolBreakdownSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getToolUsageClientToolBreakdownSecurityOption2ToJSON(
  getToolUsageClientToolBreakdownSecurityOption2:
    GetToolUsageClientToolBreakdownSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageClientToolBreakdownSecurityOption2$outboundSchema.parse(
      getToolUsageClientToolBreakdownSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageClientToolBreakdownSecurity$Outbound = {
  Option1?: GetToolUsageClientToolBreakdownSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageClientToolBreakdownSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageClientToolBreakdownSecurity$outboundSchema:
  z.ZodMiniType<
    GetToolUsageClientToolBreakdownSecurity$Outbound,
    GetToolUsageClientToolBreakdownSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetToolUsageClientToolBreakdownSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetToolUsageClientToolBreakdownSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getToolUsageClientToolBreakdownSecurityToJSON(
  getToolUsageClientToolBreakdownSecurity:
    GetToolUsageClientToolBreakdownSecurity,
): string {
  return JSON.stringify(
    GetToolUsageClientToolBreakdownSecurity$outboundSchema.parse(
      getToolUsageClientToolBreakdownSecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageClientToolBreakdownRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageClientToolBreakdownRequest$outboundSchema:
  z.ZodMiniType<
    GetToolUsageClientToolBreakdownRequest$Outbound,
    GetToolUsageClientToolBreakdownRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
        getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
      });
    }),
  );

export function getToolUsageClientToolBreakdownRequestToJSON(
  getToolUsageClientToolBreakdownRequest:
    GetToolUsageClientToolBreakdownRequest,
): string {
  return JSON.stringify(
    GetToolUsageClientToolBreakdownRequest$outboundSchema.parse(
      getToolUsageClientToolBreakdownRequest,
    ),
  );
}
